module.exports = __webpack_public_path__ + "media/images/martin-fa6ff374b9d9c85c4c3d651a2ef42df7.jpg";